import { getData, storeData,remove } from "./StoreService";
let unionId = ``;
let acId=``;
let token=``;
let searchFoundFlag='';
const getUnionId = async () => {
    if (unionId) {
      return unionId;
    }
    const data = await getData("UNION_ID");
    if (data) {
      unionId = data;
      return data;
    }
    return ``;
  };
  const storeUnionId = async (id) => {
    unionId = id;
    storeData("UNION_ID", id);
  };
  const storeAcId = async (id) => {
    acId = id;
    await storeData("cjsweiboId", id);
  };
  const getAcId = async () => {
    if (acId) return acId;
    const id = await getData("cjsweiboId");
    if (id) {
      acId = id;
      return acId;
    }
    return "";
  };
  
  const storeAccessToken = async (id) => {
    token = id;
    await storeData("TOKEN", id);
  };
  
  const getToken = async () => {
    if (token) return token;
    const t = await getData("TOKEN");
    if (t) {
      token = t;
      return token;
    }
    return "";
  };
  const setSearchFoundHideFlag = async (id) => {
    searchFoundFlag = id;
    await storeData("SEARCHFOUNDHIDEFLAG", id);
  };
  const removeSearchFoundHideFlag=async ()=>{
    await remove("SEARCHFOUNDHIDEFLAG");
  }
  const getSearchFoundHideFlag = async () => {
    if (searchFoundFlag) return searchFoundFlag;
    const t = await getData("SEARCHFOUNDHIDEFLAG");
    if (t) {
      searchFoundFlag = t;
      return searchFoundFlag;
    }
    return "";
  };
  export {
    getUnionId,
    storeUnionId,
    storeAcId,
    getAcId,
    storeAccessToken,
    getToken,
    setSearchFoundHideFlag,
    removeSearchFoundHideFlag,
    getSearchFoundHideFlag
  }